import { Asterisk } from "lucide-react";

const items = [
  "Relational Psychotherapy",
  "Somatic Awareness",
  "Transactional Analysis (TA 101)",
  "Psychodrama",
  "Online Therapy",
  "Cultural Identity & Diversity",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl font-light italic text-[#2C2825]/80 sm:text-3xl">
          {item}
        </span>
        <Asterisk className="h-5 w-5 shrink-0 text-[#C46B4E]" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div className="relative overflow-hidden border-y border-[#E3DCD3] bg-[#E8EFE8] py-6" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      <Row hidden={false} />
      <Row hidden />
    </div>
  </div>
);

export default Marquee;
